import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import { ButtonOutlined } from '../components/app-button/button'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import { LogoGa } from '../components/app-icon/Icons'
import Wrapper from '../components/wrapper'
import SiteBox from '../components/site-box/'
import Loader from '../components/app-loader/'
import CustomizeAll from '../components/сustomize-all/'
import LicenseExpired from '../components/payment/LicenseExpired'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import Typography from '@material-ui/core/Typography'
import TraficLight from '../components/traficLight'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
    marginTop: 52,
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '0 40px 30px 22px',
  },

  GaIcon: {
    margin: '0 11px 0 17px',
  },
  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 14px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
})


class GAAsync2 extends Component {
  state = {
    site: window.state.site,
    webProperty: window.state.google_analytics_settings.webProperty,
    view: window.state.google_analytics_settings.view,
    isFetching: true,
    hasStatistics: false,
    isCard: window.state.cardTest,
  }

  componentDidMount() {
    const url = '/ga/sources/sync'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: {},
    })
      .then(status)
      .then(json)
      .then(({ status, nextUrl, hasStatistics }) => {
        if (status === 'ok') {
          this.setState({
            isFetching: false,
            nextUrl,
          })
          if (hasStatistics) {
            this.setState({
              hasStatistics,
            })
          }
        }
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  render() {
    const { classes } = this.props
    const {
      site,
      webProperty,
      view,
      nextUrl,
      isFetching,
      hasStatistics,
    } = this.state

    const loader = isFetching ? <Loader /> : null

    const fetchingDataMesssage = isFetching
      ? 'Получаем данные из Google Analytics.'
      : undefined

    const getDataMesssage =
      !isFetching && hasStatistics
        ? 'Данные из Google Analytics получены'
        : !isFetching && !hasStatistics
        ? 'Данные не получены.'
        : undefined

    return (
      <Fragment>
        <LicenseExpired>
          <ActionsForUsing />
        </LicenseExpired>
        <div className={classes.pageTemplate}>
          <AppBar
              position="static"
              color="inherit"
              elevation={0}
              style={{ padding: '24px' }}
            >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              <TraficLight />
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <SiteBox
                icon={<LogoGa className={classes.GaIcon} />}
                url={`${webProperty.name} (${webProperty.id})`}
                resource={view.name}
                gutterBottom={24}
                prevUrl={'/ga/settings'}
              />

              <Wrapper shadow={4}>
                <header className={classes.header}>
                  <Typography variant="body1">
                    {fetchingDataMesssage}
                    {getDataMesssage}
                  </Typography>
                </header>

                {loader}

                <section className={classes.content}>
                  <Typography variant="body1" component="div">
                    {isFetching ? (
                      <Fragment>
                        <div>Подождите немного.</div>
                        <div>Обычно это занимает не более минуты.</div>
                      </Fragment>
                    ) : null}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    style={{ marginBottom: 16, marginTop: 32 }}
                  >
                    Для вашего удобства, мы получаем статистику переходов из
                    вашего Google Analytics, и даем вам возможность указывать
                    расходы по каждой комбинации utm-меток.
                  </Typography>
                  <Typography variant="subtitle1" style={{ marginBottom: 16 }}>
                    Для ряда рекламных сервисов вы можете подключить
                    автоматический импорт раходов.
                  </Typography>
                  <Typography variant="subtitle1">
                    {isFetching
                      ? `По тем каналам, которые недоступны для автоматического импорта
                    из рекламных площадок (например: рассылки, SEO-трафик), вы
                    можете вносить затраты вручную.`
                      : hasStatistics
                      ? `По тем каналам, которые недоступны для автоматического импорта
                    из рекламных площадок (например: рассылки, SEO-трафик), вы
                    можете вносить затраты вручную.`
                      : `Вы сможете заносить расходы по тем каналам, которые недоступны для автоматического импорта, как только мы начнем получать данные из вашего Google Analytics аккаунта`}
                  </Typography>

                  {!isFetching ? (
                    <a
                      href={nextUrl}
                      style={{
                        textDecoration: 'none',
                        marginTop: 44,
                        display: 'block',
                      }}
                    >
                      <ButtonOutlined
                        type="button"
                        color="secondary"
                        text="Завершить"
                      />
                    </a>
                  ) : (
                    undefined
                  )}
                </section>
              </Wrapper>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(GAAsync2)
